import type { ReactNode } from 'react'
import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import styles from './index.module.scss'

export type IconOnCircleProps = { icon: string; className?: string; children?: ReactNode }
export const IconOnCircle = ({ icon, className = 'bg-success', children }: IconOnCircleProps) => {
  return (
    <div className={`${styles.iconSize} p-2 rounded-circle ${className}`}>
      <Icon name={icon} />
      {children}
    </div>
  )
}
